class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));

    const url = this.dataset.url;
    if (!url) return;

    this.load(url).then((filled) => {
      if (filled) return;
      const fallback = url.replace('intent=complementary', 'intent=related');
      if (fallback !== url) this.load(fallback);
    });
  }

  load(url) {
    return fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const block = new DOMParser().parseFromString(text, 'text/html').querySelector('.cart-recos');
        if (!block) return false;
        this.innerHTML = block.outerHTML;
        return true;
      })
      .catch((e) => {
        console.error('[cart-recos]', e);
        return false;
      });
  }

  onClick(event) {
    const button = event.target.closest('button.cart-recos__add');
    if (!button) return;

    event.preventDefault();
    button.disabled = true;
    button.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((parsed) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = 'Ajouter';
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);